// extracted by mini-css-extract-plugin
export default {"root":"Button_root__8sjh4"};